import axios from 'axios';

export default {
	state: () => ({
		apiContentUrl: '/api/episerver/v2.0/search/content/',
		subCategoriesApi: '/api/CategoryListing/Children/?categoryId=',
		searchWithQuery: false,
		headerLanguage: '',
		setHashTag: true, //controls if we add hash to address bar or not
		categories: [...Array(4)].fill(''),
		subcategories: [],
		contentResults: [],
		itemsPerPage: '',
		activeParamsfromHash: {},
		skipItems: 0,
		pages: 0,
		categoriesFilter: '',
		pageTypeFilter: '',
		orderBy: '',
	}),
	getters: {
		getApiContentUrl: (state) => {
			return state.apiContentUrl;
		},
		getSubCategoriesApi: (state) => {
			return state.subCategoriesApi;
		},
		getSearchWithQuery: (state) => {
			return state.searchWithQuery;
		},
		getHeaderLanguage: (state) => {
			return state.headerLanguage;
		},
		getIfSetHashTag: (state) => {
			return state.setHashTag;
		},
		getCategories: (state) => {
			return state.categories;
		},
		getContentResults: (state) => {
			return state.contentResults;
		},
		getItemsPerPage: (state) => {
			return state.itemsPerPage;
		},
		getActiveParamsfromHash: (state) => {
			return state.activeParamsfromHash;
		},
		getSkipItems: (state) => {
			return state.skipItems;
		},
		getPages: (state) => {
			return state.pages;
		},
		getPageTypeFilter: (state) => {
			return state.pageTypeFilter;
		},
		getCategoriesFilter: (state) => {
			return state.categoriesFilter;
		},
		getOrderBy: (state) => {
			return state.orderBy;
		},
		getInitialSubCategories: (state) => {
			return state.subcategories
		},
	},
	mutations: {
		setCategories: (state, payload) => {
			state.categories[payload.index] = payload.categoryId;
		},
		setSearchWithQuery: (state, searchWithQuery) => {
			state.searchWithQuery = searchWithQuery;
		},
		setHeaderLanguage: (state, headerLanguage) => {
			state.headerLanguage = headerLanguage;
		},
		setIfSetHasgTag: (state, setHashTag) => {
			state.setHashTag = setHashTag;
		},
		setContentResults: (state, contentResults) => {
			state.contentResults = contentResults;
		},
		setItemsPerPage: (state, itemsPerPage) => {
			state.itemsPerPage = itemsPerPage;
		},
		setActiveParamsfromHash: (state, activeParamsfromHash) => {
			state.activeParamsfromHash = { ...activeParamsfromHash };
		},
		setSkipItems: (state, skipItems) => {
			state.skipItems = skipItems;
		},
		setPages: (state, pages) => {
			state.pages = pages;
		},
		setPageTypeFilter: (state, pageTypeFilter) => {
			state.pageTypeFilter = pageTypeFilter;
		},
		setCategoriesFilter: (state, categoriesFilter) => {
			state.categoriesFilter = categoriesFilter;
		},
		setOrderBy: (state, orderBy) => {
			state.orderBy = orderBy;
		},
		setSubCategories: (state, subcategories) => {
			state.subcategories = subcategories;
		},
	},
	actions: {
		setPagesNumber({ commit, state }, resultsNumber) {
			if (state.itemsPerPage < resultsNumber)
				commit('setPages', Math.ceil(resultsNumber / state.itemsPerPage));
			else
				commit('setPages', 0);
		},
		getContent: ({ dispatch, commit, state }) => {
			const
				delimiter = state.categoriesFilter.concat(state.pageTypeFilter) == '' ? '' : ' and ',
				params = {
					'filter': '(parentLink ne null and parentLink/url ne null)' + delimiter + state.categoriesFilter.concat(state.pageTypeFilter), //parent link excludes the items that are in Recycle Bin
					'expand': '*',
					'orderby': state.orderBy,
					'skip': state.skipItems,
					'top': state.itemsPerPage
				},
				activeParams = state.searchWithQuery ? state.activeParamsfromHash : params;
			commit('setSpinnerIsShown', true, { root: true })
			axios.get(state.apiContentUrl,
				{
					params: activeParams,
					headers:
					{
						'Accept': 'application/json',
						'Accept-Language': state.headerLanguage
					}
				})
				.then((response) => {
					commit('setSpinnerIsShown', false, { root: true })
					if (response.data) {
						if (!state.searchWithQuery && state.setHashTag)
							window.location.hash = new URLSearchParams(params).toString();
						else
							commit('setSearchWithQuery', false);
						commit('setContentResults', response.data.results != null ? response.data.results : []);
						dispatch('setPagesNumber', response.data.totalMatching);
					}
				})
				.catch((error) => {
					console.log(error);
					commit('setSpinnerIsShown', false, { root: true })
				});
		},
		getSubCategories: async ({ commit, state }) => {
			return axios.get(state.subCategoriesApi + state.categories[0])
				.then(response => {
					if (response.data) {
						commit('setSubCategories', response.data.categories);
					}
				})
				.catch(error => {
					console.log(error)
				});
		},
	}
}
